import { RouteService } from '../types/services/routeService';

export default class RouterSettings {
  static DefaultComponentSettings: RouteService.ComponentSettings = {
    useSuspense: true,
    usePageWrapper: true,
  };
}
